import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { alertSuccessMsg, executeStored } from 'app/main/components/Utils';
import useSettings from 'app/main/components/hooks/useSettings';
import Form from 'app/main/components/Form';
import ModuleSearchField from 'app/main/components/fields/ModuleSearchField';

interface VisibilityUsersAddDialogProps {
	module: string;
	uid: string;
	updateRefresh: VoidFunction;
}

export const showVisibilityUsersAddDialog = (props: VisibilityUsersAddDialogProps) =>
	openDialog({
		children: <VisibilityUsersAddDialog {...props} />,
		maxWidth: 'xs',
		fullWidth: true
	});

export function VisibilityUsersAddDialog({ module, uid, updateRefresh }: VisibilityUsersAddDialogProps) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings(module);

	const [userUid, setUserUid] = React.useState('');

	function handleChange(_name, value) {
		setUserUid(value);
	}

	function addUser() {
		executeStored({
			action: `st_${module}_users_add`,
			dispatch,
			data: {
				[`${settings.modu_short}_uid`]: uid,
				user_uid: userUid
			},
			successHandler: () => {
				dispatch(alertSuccessMsg(t));
				dispatch(closeDialog());
				updateRefresh();
			}
		});
	}

	return (
		<>
			<DialogTitle>{t('DIALOG_USER_ADD_TITLE')}</DialogTitle>
			<DialogContent>
				<Form id="visibilityUsersAddDialog" onSubmit={addUser}>
					<ModuleSearchField
						name="new_user"
						label={t('DIALOG_USER_ADD_USER_FIELD')}
						module="users"
						isEdit
						uid={userUid}
						sendChange={handleChange}
					/>
				</Form>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_CANCEL')}</Button>
				<Button type="submit" form="visibilityUsersAddDialog" color="secondary">
					{t('DIALOG_ACTION_ADD')}
				</Button>
			</DialogActions>
		</>
	);
}
